import { useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";

export function buildDashboardPath(path, options = {}) {
  if (path === undefined || path === null) return path;
  
  const isAdmin = options.isAdmin ?? localStorage.getItem("isAdmin") === "true";
  const isOverview = options.isOverview ?? localStorage.getItem("isOverview") === "true";
  const accountUid = options.accountUid ?? localStorage.getItem("accountUid");
  
  const cleanPath = String(path).replace(/^\/dashboard\/?/, "").replace(/^\//, "");
  
  if (isAdmin) {
    return `/dashboard/admin${cleanPath ? `/${cleanPath}` : ""}`;
  }

  if (isOverview) {
    return `/dashboard/overview${cleanPath ? `/${cleanPath}` : ""}`;
  }
  
  if (accountUid) {
    return `/dashboard/${accountUid}${cleanPath ? `/${cleanPath}` : ""}`;
  }
  
  return `/dashboard${cleanPath ? `/${cleanPath}` : "/select"}`;
}

export function useDashboardPath() {
  const { accountUid: paramAccountUid } = useParams();
  const isAdmin = localStorage.getItem("isAdmin") === "true";
  const isOverview = localStorage.getItem("isOverview") === "true";
  const accountUid = paramAccountUid || localStorage.getItem("accountUid");

  const buildPath = useCallback(
    (path) => {
      if (path === undefined || path === null) return path;
      
      const cleanPath = String(path).replace(/^\/dashboard\/?/, "").replace(/^\//, "");
      
      if (isAdmin) {
        return `/dashboard/admin${cleanPath ? `/${cleanPath}` : ""}`;
      }

      if (isOverview) {
        return `/dashboard/overview${cleanPath ? `/${cleanPath}` : ""}`;
      }
      
      if (accountUid) {
        return `/dashboard/${accountUid}${cleanPath ? `/${cleanPath}` : ""}`;
      }
      
      return `/dashboard${cleanPath ? `/${cleanPath}` : "/select"}`;
    },
    [isAdmin, isOverview, accountUid]
  );

  return { buildPath, isAdmin, isOverview, accountUid };
}

export function useNavigateDashboard() {
  const navigate = useNavigate();
  const { buildPath } = useDashboardPath();

  const navigateDashboard = useCallback(
    (path, options) => {
      navigate(buildPath(path), options);
    },
    [navigate, buildPath]
  );

  return navigateDashboard;
}

export default useDashboardPath;
